import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompaniesColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9H24V24H13C10.7909 24 9 22.2091 9 20V9Z",
			fill: "url(#paint0_linear_320_31596)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 9,
			width: 7,
			height: 22,
			fill: "#51B7D8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19.5,
			cy: 28.5,
			r: 2.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_320_31596",
			x1: 9,
			y1: 24,
			x2: 24,
			y2: 9,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#AC8EFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: .9999,
				stopColor: "#656CFF"
			})]
		}) })
	]
});
export default SvgCompaniesColored;
